import AlertIcon from "@/components/icons/parking/Alert";
import { useTranslation } from "react-i18next";

export default function NoResultsDisplay() {
    const { t } = useTranslation();
    return (
        <div 
            data-region-nav
            data-region-order={2}
            tabIndex={2} 
            data-interactive
            aria-label={t("parking.noResults.ariaLabel")} 
            className="flex flex-col items-center justify-center gap-[calc(24*var(--vh-unit))]  p-[calc(32*var(--vh-unit))] text-center min-h-[calc(400*var(--vh-unit))] focus-border "
        >
            <AlertIcon style={{ width: 'calc(50*var(--vw-unit))', height: 'calc(50*var(--vh-unit))' }} color="var(--color-sub01)" />
            <div className="text-center text-[calc(20*var(--vh-unit))] font-medium leading-[calc(32*var(--vh-unit))] text-[var(--color-sub01)] whitespace-pre-line">
                {t("parking.noResults.message")}
            </div>
        </div>
    );
}
